export default __webpack_public_path__ + "static/media/IMG_1359.cc6c080d.jpeg";